import React, { useState } from "react"
import { injectIntl } from "react-intl"
import Select from "react-select"
import { Intl } from "../../state/helpers/IntlProps"
import { IMPORT_STATUS, generateOptions } from "../../utils/inventory/importStatus"



type OwnProps = {
    intl: Intl
    multi: boolean
    value:IMPORT_STATUS | IMPORT_STATUS[]
    onChange: (selectedOpts: string[], selectedOptsLabels: string) => void
}


const ImportStatusSelect = (props: OwnProps) =>{

    const [selectedOption, setSelectedOption] = useState<IMPORT_STATUS | IMPORT_STATUS[]>(props.value)
   
   
    const onChangeSelect = (selectedOpts) => {
        setSelectedOption(selectedOpts)
        if (props.multi === true) {
            props.onChange(selectedOpts.map(option => option.value), selectedOpts.map(option => option.label).join(","))
        } else {
            props.onChange(selectedOpts.value, selectedOpts.label)
        }
    }

  
    return <Select
        id="payment-status-select"
        name="payment-status-select"
        multi={props.multi}
        value={selectedOption}
        onChange={onChangeSelect}
        options={generateOptions(props.intl)}
    />
        

}

export default injectIntl(ImportStatusSelect)


// WEBPACK FOOTER //
// ./src/inventory/components/ImportStatusSelect.tsx